module.exports = __webpack_public_path__ + "images/_/programs/h2whoa/images/characters/apprenticesFlexArms-4aeefe98ba101c125fbc6e150654e893.png";


//////////////////
// WEBPACK FOOTER
// ./programs/h2whoa/images/characters/apprenticesFlexArms.png
// module id = 430
// module chunks = 2